<div class="card">
  <div class="card-header" *ngIf="showheader">
    <h3 class="card-title"><i class="fas fa-user"></i> User info</h3>
  </div>

  <div class="card-body">

    <form [formGroup]="myform" class="container-fluid">
      <div class="form-group row">
        <label class="col-sm-3 col-form-label" for="name">Name</label>
        <div class="col-sm-9">
          <input class="form-control form-control-sm" id="name" formControlName="name" type="text" required
            placeholder="Enter name" [ngClass]="!myform.get('name').valid ? 'is-invalid' :'' ">
          <div class="invalid-feedback" *ngIf="myform.get('name').hasError('required')">
            Name is required
          </div>
          <div class="invalid-feedback" *ngIf="myform.get('name').hasError('minlength')">
            Name must be at least 3 characters long.
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label" for="name">SurName</label>
        <div class="col-sm-9">
          <input class="form-control form-control-sm" id="surname" formControlName="surname" type="text" required
            placeholder="Enter surname" [ngClass]="!myform.get('surname').valid ? 'is-invalid' :'' ">
          <div class="invalid-feedback" *ngIf="myform.get('surname').hasError('required')">
            Surname is required
          </div>
          <div class="invalid-feedback" *ngIf="myform.get('surname').hasError('minlength')">
            Surname must be at least 3 characters long.
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label" for="position">Position</label>
        <div class="col-sm-9">
          <input class="form-control form-control-sm" id="position" formControlName="position" type="text" required
            placeholder="Enter position" [ngClass]="!myform.get('position').valid ? 'is-invalid' :'' ">
          <p class="form-hint ">Position in company.</p>
          <div class="invalid-feedback" *ngIf="myform.get('position').hasError('required')">
            Position is required
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label" for="phone">Phone</label>
        <div class="col-sm-9">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-phone-alt"></i></span></div>
            <input class="form-control form-control-sm" id="phone" formControlName="phone" type="text"
              placeholder="Enter user phone" [ngClass]="!myform.get('phone').valid ? 'is-invalid' :'' ">
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label" for="description">Profile</label>
        <div class="col-sm-9">
          <mat-form-field appearance="outline" class="mat-form-control-sm">
            <mat-select formControlName="profile" placeholder="Select profiles for user" multiple>
              <mat-option *ngFor="let rol of roles" [value]="rol.id">{{rol.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback" *ngIf="myform.get('profile').hasError('required')">
            At least 1 profile is required.
          </div>
        </div>
      </div>

      <h3>Login/Password</h3>


      <div class="form-group row">
        <label class="col-sm-3 col-form-label" for="username">UserName</label>
        <div class="col-sm-9">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend"><span class="input-group-text">@</span></div>
            <input class="form-control " id="username" formControlName="username" type="email" required email
              placeholder="Enter username" [ngClass]="!myform.get('username').valid ? 'is-invalid' :'' ">
          </div>

          <p class="form-hint ">User name to access to the platform. Must be an email.</p>
          <div class="invalid-feedback" *ngIf="myform.get('username').hasError('required')">
            UserName is required
          </div>
          <div class="invalid-feedback"
            *ngIf="myform.get('username').hasError('email') && !myform.get('username').hasError('required')">
            Please enter a valid email address
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label" for="password">Password</label>
        <div class="col-sm-9">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-key"></i></span></div>
            <input class="form-control form-control-sm" id="password" formControlName="password" type="password"
              required placeholder="Enter password" [ngClass]="!myform.get('password').valid ? 'is-invalid' :'' ">
          </div>
          <div class="invalid-feedback" *ngIf="myform.get('password').hasError('required')">
            Password is required
          </div>
        </div>
      </div>
      <div class="form-group row">

        <label class="col-sm-3 col-form-label" for="confirmpassword">Confirm Password</label>
        <div class="col-sm-9">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-key"></i></span></div>
            <input class="form-control form-control-sm" id="confirmpassword" formControlName="confirmpassword"
              type="password" required placeholder="Enter password"
              [ngClass]="!myform.get('confirmpassword').valid ? 'is-invalid' :'' ">
          </div>
          <div class="invalid-feedback" *ngIf="myform.get('confirmpassword').hasError('mustMatch')">
            Password must match
          </div>
        </div>
      </div>


      <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
      <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
      <div class="buttons" *ngIf="!ismodal">
        <button mat-raised-button type="button" (click)="saveModel()" [disabled]="!myform.valid||submitted"
          class="btn btn-success btn-sm">Save</button>
      </div>
    </form>

  </div>

</div>